module.exports = __webpack_public_path__ + "img/huopinguanli-h.5b010d16.svg";